// extracted by mini-css-extract-plugin
export var addressAddress = "detailsAddress-module--address-address--9e363";
export var addressBody = "detailsAddress-module--address-body--ea873";
export var addressCarouselContainer = "detailsAddress-module--address-carousel-container--d4084";
export var addressContact = "detailsAddress-module--address-contact--9009c";
export var addressContent = "detailsAddress-module--address-content--f30fe";
export var addressContentContainer = "detailsAddress-module--address-content-container--a79c2";
export var addressFooter = "detailsAddress-module--address-footer--571f0";
export var addressFooterBack = "detailsAddress-module--address-footer-back--f2e93";
export var addressMail = "detailsAddress-module--address-mail--0fb55";
export var addressPlace = "detailsAddress-module--address-place--66ffc";
export var addressPlaceIcon = "detailsAddress-module--address-place-icon--5a0c3";
export var addressPlaceTitle = "detailsAddress-module--address-place-title--e324a";
export var addressTel = "detailsAddress-module--address-tel--e93a5";
export var addressTitle = "detailsAddress-module--address-title--b496f";
export var editButton = "detailsAddress-module--edit-button--7ddab";
export var pageAddress = "detailsAddress-module--page-address--2ef9b";
export var pageAddressAdditionalInfos = "detailsAddress-module--page-address-additional-infos--55a94";
export var separator = "detailsAddress-module--separator--f2570";